export enum SearchType {
    INDIVIDUAL,
    TEAM,
    TEAM_AND_SUBORDINATES,
    CREATED_BY_INDIVIDUAL,
}
